import { EnvironmentProviders, Provider } from '@angular/core';
import { default as de } from '../i18n/de.json';
import { registerApplication } from '@softline/application';

export const bonusabfrageProviders: Array<Provider | EnvironmentProviders> = [
  registerApplication({
    name: 'bonusabfrage',
    title: 'Bonusabfrage',
    icon: 'fa-regular fa-file-invoice-dollar',
    route: 'bonusabfrage',
    translations: { de },
    permission: 'ROLE_DFH_BONUS_SERVICE',
  }),
];
